{
  "welcome": {
    "title": {
      "part1": "Tu mejor compañía para un ",
      "part2": "estilo de vida",
      "part3": " sobrio"
    },
    "button": {
      "start": "Continuar con mi correo",
      "login": "Acceder a mi cuenta",
      "google": "Continuar con Google"
    },
    "divider": {
      "or": "O"
    },
    "google": {
      "errorTitle": "No se pudo continuar",
      "errorMessage": "Hubo un problema al iniciar sesión con Google. Inténtalo de nuevo."
    }
  },
  "auth": {
    "login": {
      "title": "Iniciar sesión",
      "welcomeBack": "Inicia sesión para acceder a tu cuenta",
      "welcomeBackReturning": "¡Qué bueno tenerte de vuelta en Padrinho!",
      "member": "Miembro",
      "switchUser": "Cambiar",
      "email": "Correo electrónico",
      "emailPlaceholder": "tu@correo.com",
      "password": "Contraseña",
      "passwordPlaceholder": "Ingresa tu contraseña",
      "button": "Iniciar sesión",
      "forgot": "¿Olvidaste tu contraseña?",
      "forgotPassword": "¿Olvidaste tu contraseña?",
      "errorTitle": "Error",
      "errorFillFields": "Por favor completa todos los campos",
      "errorInvalidCredentials": "Credenciales inválidas",
      "errorEmailNotConfirmed": "Correo no confirmado",
      "errorTooManyAttempts": "Demasiados intentos de inicio de sesión. Intenta de nuevo en unos minutos.",
      "errorConnection": "Error de conexión",
      "errorRetry": "Intentar de nuevo",
      "errorCancel": "Cancelar",
      "errorConfig": "Configuración",
      "errorTemporary": "Error temporal del servidor. Intenta de nuevo más tarde.",
      "errorUnexpected": "Error inesperado",
      "errorUnexpectedMessage": "Error inesperado. Intenta de nuevo."
    },
    "forgotPassword": {
      "title": "Restablecer contraseña",
      "subtitle": "Ingresa tu correo para recibir instrucciones para restablecer tu contraseña",
      "email": "Correo electrónico",
      "emailPlaceholder": "tu@correo.com",
      "button": "Enviar instrucciones",
      "buttonLoading": "Enviando...",
      "errorTitle": "Error",
      "errorEmail": "Por favor ingresa tu correo",
      "errorRateLimit": "Límite de intentos excedido",
      "errorUserNotFound": "No encontramos una cuenta con este correo",
      "successTitle": "Correo enviado",
      "successMessage": "Revisa tu bandeja de entrada para restablecer tu contraseña",
      "successButton": "OK",
      "errorUnexpected": "Ocurrió un error inesperado"
    },
    "resetPassword": {
      "title": "Nueva contraseña",
      "subtitle": "Ingresa una nueva contraseña para tu cuenta",
      "newPassword": "Nueva contraseña",
      "confirmPassword": "Confirmar contraseña",
      "newPasswordPlaceholder": "Ingresa tu nueva contraseña",
      "confirmPasswordPlaceholder": "Confirma tu nueva contraseña",
      "button": "Restablecer contraseña",
      "buttonLoading": "Actualizando...",
      "errorTitle": "Error",
      "errorFillFields": "Por favor completa todos los campos",
      "errorPasswordMismatch": "Las contraseñas no coinciden",
      "errorInvalidPassword": "Contraseña Inválida",
      "errorPasswordRequirements": "Tu contraseña debe cumplir con los siguientes requisitos:\n\n• Mínimo 8 caracteres\n• Una letra mayúscula\n• Una letra minúscula\n• Un número",
      "errorGeneric": "Falló al restablecer contraseña",
      "successTitle": "Contraseña cambiada",
      "successMessage": "¡Tu contraseña ha sido cambiada con éxito!",
      "successButton": "OK",
      "errorUnexpected": "Ocurrió un error inesperado"
    },
    "verifyCode": {
      "title": "Verificar código",
      "subtitle": "Enviamos un código de 6 dígitos a {email}",
      "button": "Verificar",
      "resendButton": "Reenviar código",
      "contactEmail": "contacto@padrinho.app",
      "contactMessage": "Revisa el correo utilizado o contáctanos:",
      "errorDigits": "Por favor ingresa el código de 6 dígitos",
      "errorInvalidCode": "Código inválido o expirado",
      "errorVerification": "Error en la verificación. Intenta de nuevo.",
      "errorResend": "Error al reenviar código. Intenta de nuevo.",
      "successResend": "Éxito",
      "successResendMessage": "¡Código reenviado con éxito!"
    },
    "sessionExpired": {
      "title": "Sesión expirada",
      "message": "Tu sesión ha expirado. Inicia sesión nuevamente para continuar.",
      "button": "Iniciar sesión"
    }
  },
  "onboarding": {
    "title": "Comienza aquí",
    "sobrietySet": "Definir tiempo de sobriedad",
    "firstMessage": "Iniciar conversación con Bill",
    "firstCheckin": "Ir al primer encuentro online",
    "firstTrailStep": "Iniciar sendero de recuperación",
    "firstDiaryNote": "Registrar en mi diario",
    "profilePhoto": "Poner mi foto de perfil",
    "firstMessagePrompt": "Hola Bill, ¿cómo puedes ayudarme?",
    "header": "Incorporación",
    "welcome": {
      "title": "¡Tu camino hacia una vida sobria comienza hoy!",
      "subtitle": "Aquí en la aplicación encontrarás excelentes herramientas para apoyar tu progreso",
      "button": "¡Vamos allá!",
      "features": {
        "bill": "Bill, tu asistente personal",
        "billDesc": "Conversaciones inteligentes 24/7 para apoyo y orientación",
        "diary": "Diario y Check-ins",
        "diaryDesc": "Registra pensamientos, sentimientos y participación en reuniones en línea",
        "clock": "Reloj de Sobriedad",
        "clockDesc": "Marca tu progreso en el tiempo y celebra cada logro",
        "progress": "Progreso en Tiempo Real",
        "progressDesc": "Sigue tu progreso día a día",
        "connection": "Conexión con Clínicas",
        "connectionDesc": "Comunicación directa con tu clínica de salud",
        "privacy": "Privacidad Total",
        "privacyDesc": "Tus datos están protegidos y son confidenciales"
      }
    },
    "name": {
      "title": "Para empezar, ¿cómo podemos llamarte?",
      "subtitle": "Puedes elegir un apodo",
      "placeholder": "Ingresa tu nombre o apodo",
      "required": "Nombre requerido",
      "requiredMessage": "Por favor, ingresa tu nombre o apodo.",
      "error": "Error",
      "errorMessage": "No se pudo guardar tu nombre. Intenta de nuevo."
    },
    "interests": {
      "title": "¿Qué temas te interesan?",
      "titleWithName": "¿qué temas te interesan?",
      "subtitle": "Elige al menos 3 temas de interés",
      "insufficient": "Selección Insuficiente",
      "insufficientMessage": "Por favor, elige al menos 3 temas de interés.",
      "error": "Error",
      "errorMessage": "No se pudieron guardar tus intereses. Intenta de nuevo."
    },
    "gender": {
      "title": "¿Cuál es tu género?",
      "subtitle": "Selecciona la opción que mejor te representa",
      "feminine": "Femenino",
      "masculine": "Masculino",
      "nonBinary": "No binario",
      "preferNotToSay": "Prefiero no decir",
      "required": "Selección Requerida",
      "requiredMessage": "Por favor, selecciona una opción.",
      "error": "Error",
      "errorMessage": "No se pudo guardar tu preferencia. Intenta de nuevo."
    },
    "supportRecipient": {
      "title": "Hoy, ¿para quién buscas apoyo?",
      "subtitle": "Selecciona la opción que mejor describe tu situación",
      "self": "Para mí",
      "friend": "Para un(a) amigo(a)",
      "family": "Para un familiar",
      "required": "Selección Requerida",
      "requiredMessage": "Por favor, selecciona una opción.",
      "error": "Error",
      "errorMessage": "No se pudo guardar tu preferencia. Intenta de nuevo."
    },
    "clinic": {
      "title": "Conéctate con tu clínica",
      "subtitle": "Selecciona una opción para vincularla a tu cuenta. Si no tienes clínica, elige Padrinho.",
      "continue": "Continuar",
      "required": "Selecciona una opción para continuar.",
      "loading": "Cargando clínicas...",
      "empty": "No hay clínicas disponibles ahora. Inténtalo de nuevo en unos instantes.",
      "loadError": "No pudimos cargar las clínicas. Revisa tu conexión e inténtalo de nuevo.",
      "saveError": "No pudimos guardar tu elección. Inténtalo de nuevo.",
      "errorTitle": "Elección de clínica",
      "retry": "Intentar de nuevo",
      "choose": "Elegir clínica",
      "resume": "Retomar registro",
      "retryCompletion": "El registro se actualizó mientras completabas este paso. Tus respuestas se conservaron. Intenta finalizar de nuevo.",
      "incomplete": "Faltan algunas respuestas del registro o no se pudieron leer. Retoma el registro para revisar tus respuestas.",
      "completeError": "No pudimos completar el registro ahora. Tus respuestas se conservaron. Inténtalo de nuevo.",
      "rateLimited": "Demasiados intentos. Espera un minuto e intenta finalizar de nuevo. Tus respuestas se conservaron.",
      "unavailable": "Esta clínica ya no está disponible. Elige otra opción.",
      "serverNotReady": "Este paso está disponible en la vista previa, pero el servidor publicado aún necesita una actualización para completar el registro con tu clínica. Tus respuestas se han conservado."
    },
    "sponsorship": {
      "title": "¿Te gustaría tener un padrino?",
      "subtitle": "Elige una opción sobre apadrinamiento",
      "godmother": "Sí, una madrina",
      "godfather": "Sí, un padrino",
      "maybeLater": "Tal vez después",
      "dontWant": "No quiero",
      "required": "Selección Requerida",
      "requiredMessage": "Por favor, selecciona una opción.",
      "error": "Error",
      "errorMessage": "No se pudo guardar tu preferencia. Intenta de nuevo."
    },
    "addictionType": {
      "title": "¿Con qué tipo de adicción te identificas actualmente?",
      "subtitle": "Puedes seleccionar más de 1 opción",
      "options": {
        "alcohol": "Alcohol",
        "nicotine": "Nicotina",
        "drugs": "Drogas / Psicoactivos",
        "gambling": "Juegos de azar",
        "sex": "Sexo",
        "pornography": "Pornografía",
        "other": "Otros"
      },
      "required": "Selección Requerida",
      "requiredMessage": "Por favor, selecciona al menos una opción.",
      "error": "Error",
      "errorMessage": "No se pudo guardar tu selección. Intenta de nuevo."
    },
    "frequency": {
      "title": "¿Con qué frecuencia recurres a tu adicción?",
      "options": {
        "onceWeek": "1 vez a la semana",
        "twoThreeWeek": "2 a 3 veces a la semana",
        "fourFiveWeek": "4 a 5 veces a la semana",
        "daily": "Todos los días",
        "alreadySober": "Ya estoy en sobriedad",
        "notAddicted": "No soy adicto"
      },
      "required": "Selección Requerida",
      "requiredMessage": "Por favor, selecciona una opción.",
      "error": "Error",
      "errorMessage": "No se pudo guardar tu selección. Intenta de nuevo."
    },
    "goal": {
      "title": "¿Cuál es tu principal objetivo dentro de Padrinho?",
      "options": {
        "reduceControl": "Reducir o controlar el comportamiento compulsivo",
        "fullAbstinence": "Alcanzar la abstinencia completa",
        "maintainSobriety": "Mantener la sobriedad o equilibrio diario",
        "identifyTriggers": "Identificar gatillos y construir estrategias de afrontamiento",
        "healthyHabits": "Desarrollar hábitos saludables como sustitutos",
        "rebuildRelationships": "Reconstruir o fortalecer relaciones y redes de apoyo",
        "monitorProgress": "Monitorear mi propio progreso y celebrar pequeñas victorias"
      },
      "required": "Selección Requerida",
      "requiredMessage": "Por favor, selecciona una opción.",
      "error": "Error",
      "errorMessage": "No se pudo guardar tu selección. Intenta de nuevo."
    },
    "notifications": {
      "title": "¿Podemos enviarte algunas notificaciones?",
      "subtitle": "Solo para crear una conexión genial, no te enviaremos SPAM, ¡lo prometo!",
      "button": "¡Claro! Envíalas"
    },
    "success": {
      "welcomeMessage": "¡{name}, te damos la bienvenida a Padrinho!",
      "welcomeMessageFallback": "¡Nombre, te damos la bienvenida a Padrinho!",
      "recoveryMessage": "Tu recuperación continúa hoy, {date}",
      "buttonStart": "Comenzar",
      "buttonRetry": "Intentar de Nuevo",
      "greeting": "Qué bueno que llegaste,",
      "joinPrefix": "Únete a ",
      "joinHighlight": "más de {count} personas en línea",
      "joinSuffix": " ahora para compartir y apoyarse",
      "uploadPhoto": "Subir foto de perfil",
      "uploading": "Subiendo foto...",
      "buttonContinue": "¡Ok, vamos!"
    },
    "firstAccess": {
      "stepNumber": "6",
      "title": "Conéctate a Padrinho",
      "subtitle": "Ingresa el correo que usarás para acceder a tu cuenta de Padrinho",
      "emailLabel": "Correo electrónico",
      "emailPlaceholder": "Ingresa tu correo",
      "termsTitle": "Términos y Políticas de Privacidad",
      "termsAccept": "Acepto los ",
      "termsLink": "términos y políticas de privacidad",
      "termsAppName": " de la app Padrinho.",
      "errors": {
        "emailRequired": "Error",
        "emailRequiredMessage": "Por favor, ingresa tu correo",
        "emailInvalid": "Error",
        "emailInvalidMessage": "Por favor, ingresa un correo válido",
        "termsRequired": "Error",
        "termsRequiredMessage": "Debes aceptar los términos para continuar",
        "userExists": "Cuenta Existente",
        "userExistsMessage": "Ya existe una cuenta con este correo. Por favor, inicia sesión usando tu contraseña.",
        "cancel": "Cancelar",
        "goToLogin": "Ir a Iniciar Sesión",
        "sendError": "Error",
        "sendErrorMessage": "Error al enviar código de verificación. Inténtalo de nuevo.",
        "unexpectedError": "Error",
        "unexpectedErrorMessage": "Error inesperado. Inténtalo de nuevo."
      }
    }
  },
  "sobriety": {
    "card": {
      "title": "Reloj de sobriedad",
      "setupDescription": "Cuenta tus días en sobriedad",
      "todayLabel": "Hoy, {day} de {month}",
      "hoursLabel": "+ 24 horas",
      "daysMessage": "¡Llevas {days} {daysWord} sobrio!",
      "day": "día",
      "days": "días",
      "congratsTitle": "¡Felicitaciones! Te mantuviste sobrio",
      "year": "año",
      "years": "años",
      "month": "mes",
      "months": "meses",
      "dayLabel": "día",
      "daysLabel": "días",
      "hour": "hora",
      "hours": "horas",
      "share": "Compartir",
      "restart": "Reiniciar",
      "edit": "Editar",
      "totalDaysMessage": "Llevas {days} días en sobriedad",
      "totalDaysPrefix": "Llevas ",
      "totalDaysSuffix": " en sobriedad",
      "totalDaysWord": "días",
      "addWidget": "Agregar al inicio"
    },
    "share": {
      "message": "¡Llevo {days} días en sobriedad! 🎉 #Padrinho #Sobriedad",
      "imageText": "Hoy estoy completando\n{days} días en sobriedad"
    },
    "clock": {
      "title": "Reloj de sobriedad",
      "cancel": "Cancelar",
      "question": "Cuéntanos cuál es tu momento actual",
      "option1": "Tuve una recaída y estoy comenzando de nuevo",
      "option2": "He estado sobrio durante un tiempo",
      "option3": "Estoy comenzando hoy",
      "continue": "Continuar"
    },
    "input": {
      "title": "Reloj de sobriedad",
      "subtitle": "¿Cuándo fue la última vez que bebiste?",
      "placeholder": "DD/MM/AAAA",
      "helperText": "Ingresa la fecha en formato DD/MM/AAAA",
      "daysLabel": "Días de sobriedad",
      "button": "Comenzar a contar",
      "invalidDate": "Fecha inválida",
      "futureDate": "La fecha no puede estar en el futuro"
    },
    "relapse": {
      "title": "Reloj de sobriedad",
      "mainTitle": "Recuerda, las recaídas son parte del proceso",
      "subtitle": "Lo más importante son tus logros y aprendizajes hasta hoy",
      "reminderButton": "Escribe un recordatorio",
      "continueButton": "Continuar",
      "noteTitle": "Recordatorio sobre recaída"
    },
    "congratulations": {
      "title": "Reloj de sobriedad",
      "mainTitle": "¡Felicitaciones! Hoy comienzas un momento importante en tu camino",
      "subtitle": "Recuerda, lo importante son tus logros y aprendizajes hasta hoy",
      "button": "¡Vamos allá!"
    },
    "shareCard": {
      "line1": "Hoy estoy completando",
      "days": "días",
      "line2": "en sobriedad"
    },
    "sharePage": {
      "title": "Reloj de sobriedad",
      "shareButton": "Enviar por mensaje",
      "saveButton": "Descargar",
      "sharing": "Compartiendo...",
      "saving": "Guardando...",
      "savedTitle": "Imagen guardada",
      "savedMessage": "La imagen ha sido guardada en tu galería",
      "errorTitle": "Error",
      "errorMessage": "No se pudo procesar la imagen. Inténtalo de nuevo.",
      "permissionDeniedTitle": "Permiso denegado",
      "permissionDeniedMessage": "Necesitamos permiso para guardar en la galería",
      "sharingUnavailableTitle": "Compartir no disponible",
      "sharingUnavailableMessage": "Compartir no está disponible en este dispositivo",
      "shareDialogTitle": "Compartir logro"
    }
  },
  "navbar": {
    "bill": "Bill",
    "meetings": "Reuniones"
  },
  "bill": {
    "welcome": {
      "title": "Hola, soy Bill",
      "subtitle": "Tu padrino digital"
    },
    "loading": {
      "connecting": "Bill está respondiendo...",
      "typing": "Escribiendo..."
    },
    "suggestions": {
      "startTrail": "Iniciar mi camino",
      "diaryGuide": "Cómo usar mi diario",
      "meetingTimes": "Horarios de reuniones"
    },
    "input": {
      "placeholder": "Envía tu mensaje a Bill"
    },
    "plusBar": {
      "continueConversation": "Continúa conversando con Bill",
      "remainingMessages": "Aún tienes ",
      "remainingMessagesEnd": " mensajes",
      "sendMessage": "Envía tu mensaje a Bill"
    },
    "errors": {
      "technicalIssue": "Lo siento, tuve un problema técnico procesando tu mensaje. ¿Puedes intentar de nuevo?",
      "monthlyLimitReached": "Has alcanzado tu límite mensual de mensajes. Actualiza a Padrinho Plus para conversaciones ilimitadas con Bill."
    }
  },
  "chat": {
    "title": "Bill - Tu Asistente",
    "placeholder": "Escribe tu mensaje...",
    "send": "Enviar",
    "typing": "Bill está escribiendo...",
    "empty": "Inicia una conversación con Bill",
    "error": "Error al enviar mensaje",
    "connecting": "Conectando con Bill...",
    "messageTitle": "Mensaje de Bill",
    "today": "Hoy",
    "yesterday": "Ayer",
    "suggestedActions": {
      "startTrail": "Iniciar mi camino",
      "diaryGuide": "Cómo usar mi diario"
    },
    "contextMenu": {
      "share": "Compartir",
      "bookmark": "Guardar",
      "remove": "Remover",
      "edit": "Editar"
    },
    "clearConversation": {
      "title": "Nueva conversación",
      "message": "Esto limpiará tu conversación actual con Bill. Tus mensajes guardados en el diario se mantendrán. Puedes empezar de nuevo en cualquier momento.",
      "confirm": "Iniciar nueva conversación"
    }
  },
  "diary": {
    "headerTitle": "Diario",
    "title": "Diario de Bienestar",
    "tabs": {
      "relogio": "Reloj",
      "notas": "Notas",
      "missoes": "Misiones"
    },
    "clock": {
      "emptyTitle": "Sigue tus días de sobriedad",
      "startButton": "Iniciar conteo",
      "communityCount": "Tú y {count} personas están en sobriedad",
      "share": "Compartir",
      "restart": "Reiniciar",
      "edit": "Editar",
      "anos": "Años",
      "meses": "Meses",
      "dias": "Días",
      "horas": "Horas",
      "shareMessage": "días sobrio! 🎉 #Padrinho"
    },
    "addEntry": "Nueva Entrada",
    "mood": "¿Cómo te sientes?",
    "gratitude": "¿Por qué estás agradecido?",
    "notes": "Notas",
    "save": "Guardar",
    "delete": "Eliminar",
    "empty": "Sin entradas aún",
    "emptyState": {
      "notesTitle": "Registra una reflexión para hoy",
      "notesButton": "Crear nota",
      "title": "Guarda tus memorias a lo largo de tu camino",
      "subtitle": "Aquí puedes registrar pensamientos, sentimientos o guardar mensajes de Bill para recordar en el futuro"
    },
    "today": "Hoy",
    "yesterday": "Ayer",
    "noteDeleted": "¡Nota eliminada con éxito!",
    "checkinRemoved": "¡Check-in removido con éxito!",
    "checkinHidden": "¡Check-in ocultado del diario con éxito!",
    "relapseHidden": "¡Registro ocultado del diario con éxito!",
    "messageRemoved": "¡Mensaje removido del diario con éxito!",
    "relapse": {
      "title": "Empezar de nuevo",
      "message": "¡Las recaídas son parte del proceso! Continúa desde donde lo dejaste"
    },
    "deleteError": "Error al eliminar. Por favor intenta de nuevo.",
    "removeMessageError": "Error al remover mensaje. Por favor intenta de nuevo.",
    "sentimentLabel": "Sentimiento",
    "contextLabel": "Contexto",
    "checkinText": "Check-in 📍 Asististe a la reunión {meetingName} a las {time}",
    "filters": {
      "author": "Autor",
      "period": "Período",
      "sentiment": "Sentimiento",
      "sentimentMultiple": "{count} sentimientos",
      "you": "Tú",
      "bill": "Bill",
      "last7days": "Últimos 7 días",
      "last15days": "Últimos 15 días",
      "last30days": "Últimos 30 días",
      "all": "Todos",
      "search": "Buscar en tus notas..."
    },
    "actions": {
      "options": "Opciones",
      "editEntry": "Editar entrada",
      "deleteEntry": "Eliminar entrada",
      "editNote": "Editar nota",
      "deleteNote": "Eliminar nota",
      "removeCheckin": "Eliminar check-in",
      "hideFromDiary": "Ocultar del diario",
      "removeFromDiary": "Eliminar del diario"
    },
    "buttons": {
      "sentiment": "Sentimiento",
      "note": "Nota"
    },
    "search": {
      "cancel": "Cancelar",
      "results": "{count} resultado encontrado",
      "resultsPlural": "{count} resultados encontrados"
    },
    "emotions": {
      "feliz": "Feliz",
      "animado": "Emocionado",
      "tranquilo": "Tranquilo",
      "cansado": "Cansado",
      "frustrado": "Frustrado",
      "triste": "Triste",
      "estressado": "Estresado",
      "irritado": "Irritado",
      "ansioso": "Ansioso"
    },
    "categories": {
      "vida-pessoal": "Vida Personal",
      "trabalho": "Trabajo",
      "relacionamentos": "Relaciones",
      "saude": "Salud",
      "financas": "Finanzas",
      "sobriedade": "Sobriedad",
      "lazer": "Ocio",
      "espiritualidade": "Espiritualidad",
      "educacao": "Educación",
      "outros": "Otros",
      "and": "y"
    },
    "sentiment": {
      "title": "Sentimiento",
      "question": "¿Cómo te sientes hoy?",
      "nextButton": "Siguiente",
      "writeMemory": "Escribe un recuerdo sobre este sentimiento",
      "context": "¿En qué contexto te sientes así?",
      "savedSuccess": "registrado con éxito! 💚",
      "noteSavedSuccess": "¡Nota guardada con éxito!",
      "noteUpdatedSuccess": "¡Nota actualizada con éxito!",
      "cannotEdit": "Los check-ins no pueden ser editados, solo removidos.",
      "removed": "¡Check-in removido con éxito!",
      "hidden": "¡Check-in ocultado del diario con éxito!",
      "deleted": "¡Registro de sentimiento eliminado con éxito!",
      "error": "Error al eliminar registro. Intenta de nuevo.",
      "removeError": "Error al remover mensaje. Intenta de nuevo.",
      "placeholderWithCategory": "Me siento {emotion} con {category}...",
      "placeholderNoCategory": "Me siento {emotion}...",
      "contextLabel": "Contexto:"
    },
    "addNote": {
      "titleNew": "Nueva nota",
      "titleEdit": "Editar nota",
      "titleEditEntry": "Editar entrada",
      "placeholder": "¿Qué tienes en mente ahora?",
      "userFallback": "Usuario"
    }
  },
  "meetings": {
    "title": "Encuentros",
    "tabs": {
      "explore": "Explorar",
      "saved": "Guardados",
      "para_voce": "Para ti"
    },
    "salvos": {
      "empty": {
        "title": "Aún no hay encuentros guardados",
        "subtitle": "Toca el corazón en cualquier encuentro para encontrarlo aquí más tarde.",
        "cta": "Explorar encuentros"
      }
    },
    "filters": {
      "time": "Horario",
      "day": "Día de la semana",
      "category": "Categoría",
      "clear": "Limpiar filtros"
    },
    "time": {
      "todayAt": "Hoy a las"
    },
    "sections": {
      "happeningNow": "Sucediendo ahora",
      "suggested": "Sugeridos para ti",
      "otherMeetings": "Otros encuentros"
    },
    "empty": {
      "title": "Aún no has guardado un encuentro",
      "subtitle": "¡Guarda un encuentro para que puedas recordarlo después!"
    },
    "search": {
      "placeholder": "Buscar por nombre, tipo o plataforma...",
      "cancelButton": "Cancelar",
      "results": "{count} resultado encontrado",
      "resultsPlural": "{count} resultados encontrados",
      "preset1": "Grupo Camino",
      "preset2": "Compartir"
    },
    "actions": {
      "favorite": "Guardar",
      "favorited": "Guardado",
      "unfavorite": "Quitar",
      "enter": "Entrar",
      "invite": "Invitar"
    },
    "sectionTitles": {
      "upcoming": "Próximos encuentros"
    },
    "status": {
      "liveNow": "En vivo ahora",
      "live": "En vivo"
    },
    "carousel": {
      "title": "Encuentros en línea",
      "viewAll": "Ver todos",
      "loading": "Cargando próximos encuentros...",
      "empty": "No se encontraron encuentros próximos"
    },
    "labels": {
      "password": "Contraseña",
      "schedule": "Horarios",
      "place": "Plataforma",
      "participants": "Participantes"
    },
    "detail": {
      "infoTitle": "Información del encuentro",
      "totalParticipations": "check-ins en total",
      "liveNow": "En vivo ahora",
      "at": "a las",
      "tipsTitle": "Consejos para la reunión",
      "tipCamera": "No necesitas encender la cámara",
      "tipMute": "Puedes solo escuchar, nadie te llamará por tu nombre",
      "tipHeart": "Las personas son como tú: mejorando un día a la vez",
      "tipHonesty": "No existe correcto o incorrecto — solo sinceridad",
      "tipLeave": "Si lo deseas, puedes salir de la reunión en cualquier momento",
      "programacao": "Programación",
      "programacaoCount": "{count} encuentros semanales",
      "programacaoCountOne": "1 encuentro semanal",
      "programacaoSingleSession": "Sesión única",
      "programacaoRow": "{weekday} · {time} · {category}"
    },
    "form": {
      "title": {
        "new": "Nuevo Encuentro",
        "edit": "Editar Encuentro"
      },
      "fields": {
        "name": {
          "label": "Nombre del Encuentro *",
          "placeholder": "Ej: Círculo de Apoyo Matutino"
        },
        "link": {
          "label": "Enlace del Encuentro *",
          "placeholder": "https://zoom.us/j/123456789"
        },
        "time": {
          "label": "Horario *",
          "placeholder": "Ej: 08:00"
        },
        "category": {
          "label": "Categoría *"
        },
        "group": {
          "label": "Grupo",
          "noGroups": "No hay grupos disponibles"
        },
        "weekdays": {
          "label": "Días de la Semana *"
        },
        "platform": {
          "label": "Plataforma *",
          "inPerson": "Presencial"
        },
        "period": {
          "label": "Período *"
        },
        "region": {
          "label": "Región",
          "placeholder": "Ej: Madrid"
        },
        "password": {
          "label": "Contraseña de la Reunión",
          "placeholder": "Contraseña opcional"
        },
        "description": {
          "label": "Descripción",
          "placeholder": "Descripción del encuentro"
        },
        "headerImage": {
          "label": "URL de la Imagen de Encabezado",
          "placeholder": "https://ejemplo.com/imagen.jpg",
          "hint": "Pega la URL completa de la imagen que aparecerá en el encabezado del encuentro"
        }
      },
      "categories": {
        "supportGroup": "Grupo de Apoyo",
        "workshop": "Taller",
        "meditation": "Meditación",
        "therapy": "Terapia",
        "sharing": "Compartir",
        "reuniaoNovos": "Reunión para Recién Llegados",
        "reuniaoPartilhas": "Reunión de Compartir",
        "reuniaoTematica": "Reunión Temática",
        "reuniaoEstudoLiteratura": "Estudio de Literatura",
        "reuniaoAteusAgnosticos": "Ateos y Agnósticos",
        "reuniaoLgbtqiapn": "LGBTQIAPN+",
        "reuniaoCodependentes": "Codependientes",
        "reuniaoPassos": "Reunión de Pasos",
        "reuniaoTradicoes": "Reunión de Tradiciones"
      },
      "platforms": {
        "zoom": "Zoom",
        "googleMeet": "Google Meet",
        "microsoftTeams": "Microsoft Teams",
        "jitsiMeet": "Jitsi Meet",
        "discord": "Discord",
        "inPerson": "Presencial"
      },
      "actions": {
        "cancel": "Cancelar",
        "saveChanges": "Guardar Cambios",
        "create": "Crear Encuentro"
      }
    },
    "alerts": {
      "notFound": "Encuentro no encontrado",
      "loadError": "Error al cargar encuentro",
      "loginRequired": "Es necesario iniciar sesión para entrar al encuentro",
      "linkNotAvailable": "Enlace del encuentro no disponible",
      "fillRequired": "Por favor completa todos los campos obligatorios y selecciona al menos un día de la semana.",
      "saveError": "Error al guardar encuentro",
      "saveSuccess": "¡Encuentro agregado con éxito!",
      "updateSuccess": "¡Encuentro actualizado con éxito!",
      "genericError": "Ocurrió un error al guardar el encuentro",
      "unauthorized": "Acceso no autorizado"
    },
    "share": {
      "greeting": "¡Hola! Me gustaría invitarte a participar en un encuentro conmigo. 🙏",
      "schedule": "Horarios",
      "link": "Enlace",
      "password": "Contraseña",
      "downloadApp": "O descarga la aplicación Padrinho en www.padrinho.app/downloads"
    },
    "clipboard": {
      "passwordCopied": "¡Contraseña copiada!"
    },
    "errors": {
      "loading": "Error al cargar encuentros",
      "loadingSaved": "Error al cargar encuentros guardados",
      "updateSaved": "Error al actualizar encuentro guardado",
      "loadMeetingInfo": "No se pudo cargar la información del encuentro"
    },
    "errorLoading": "Error al cargar encuentros",
    "errorLoadingSaved": "Error al cargar encuentros guardados",
    "saved_success": "¡Perfecto! Te notificaremos cuando comience este encuentro.",
    "removed": "¡Encuentro eliminado de guardados!",
    "loginToSave": "Inicia sesión para guardar encuentros",
    "onboarding": {
      "welcome": {
        "title": "Hola {name}, te damos la bienvenida a los encuentros",
        "subtitle": "Aquí podrás conectarte con personas que tienen el mismo enfoque que tú. Pero antes, algunos consejos para participar.",
        "cta": "¡Vamos!",
        "accordion1": {
          "title": "¿Qué es un encuentro?",
          "content": "Participar en una reunión puede parecer difícil al principio, pero es uno de los pasos más importantes para quien quiere cambiar de vida. Las reuniones son espacios seguros donde personas como tú comparten experiencias, fortaleza y esperanza. Escuchas cómo ellas manejaron la dependencia, cómo encontraron soluciones para los conflictos del día a día y cómo están construyendo una vida mejor hoy."
        },
        "accordion2": {
          "title": "¿Qué pasa en un encuentro?",
          "content": "Al inicio, el coordinador hace una breve apertura y, en algunas reuniones, hay un momento de silencio o la Oración de la Serenidad. Puedes — si quieres — decir que es tu primera vez, pero no es obligatorio. Luego escuchamos reflexiones, compartidas y, al final, hay un momento de unión o una lectura que refuerza el compromiso colectivo.\n\nCuando termina la reunión, muchos se quedan a conversar. Tú decides si quieres participar — sin presión."
        },
        "accordion3": {
          "title": "¿Por qué participar?",
          "content": "Ir a una reunión no es solo \"comparecer\"; es invertir en ti mismo. Aquí hay beneficios inmediatos que puedes sentir desde la primera participación:\n\n1. La reunión trae soluciones reales para la vida diaria.\nAl escuchar otras historias, surgen nuevas perspectivas para manejar conflictos, emociones y desafíos que antes parecían imposibles.\n\n2. La reunión crea compromiso — y el compromiso crea cambio.\nEntrar a la sala, incluso en silencio, ya es una forma de romper la rutina antigua y construir un nuevo camino.\n\n3. La reunión alivia la mente y el corazón.\nHablar — o solo escuchar — ayuda a vaciar la presión interna. Sales más ligero, más tranquilo y más preparado."
        }
      },
      "step": "Pregunta {current} de {total}",
      "next": "Siguiente",
      "back": "Volver",
      "q1": {
        "question": "Para empezar, ¿alguna vez has participado en una reunión de grupos anónimos?",
        "options": {
          "never": "Nunca he participado",
          "once": "Participé una vez",
          "few_times": "Participé algunas veces",
          "long_periods": "Participé por largos períodos",
          "for_someone": "No es para mí, pero alguien cercano ya participa"
        }
      },
      "q2": {
        "question": "¿Qué te trajo aquí en este momento?",
        "options": {
          "iniciante": "Estoy perdido y necesito entender si los encuentros me pueden ayudar.",
          "novo": "Ya escuché sobre los encuentros y quiero saber cómo funcionan antes de entrar.",
          "visitante": "Ya fui a un encuentro pero no tuve una buena experiencia.",
          "recaido": "Quiero volver a empezar después de una recaída.",
          "itinerante": "Busco un encuentro de calidad para mantener mi sobriedad.",
          "codependente": "Estoy aquí por alguien que amo."
        }
      },
      "q3": {
        "question": "¿Qué necesitas más ahora?",
        "options": {
          "courage": "Coraje para dar el primer paso",
          "information": "Información sobre cómo funciona",
          "emotional_support": "Apoyo emocional de personas que entienden",
          "talk_to_others": "Hablar con otras personas en recuperación",
          "recovery_after_relapse": "Recuperar fuerzas después de una recaída",
          "learn_to_help": "Aprender cómo ayudar a alguien que amo"
        }
      },
      "result": {
        "title": "{name}, {count} encuentros combinan contigo",
        "titleSingular": "{name}, 1 encuentro combina contigo",
        "subtitle": "Únete a más de {userCount} personas en línea para intercambios y apoyo",
        "fallback": "Encuentros para ti",
        "fallbackSubtitle": "Todavía estamos categorizando los encuentros. Explora todos abajo mientras tanto.",
        "join": "Participar",
        "explore": "Ver todos los encuentros",
        "saving": "Estamos buscando los mejores encuentros para ti"
      },
      "paraVoce": {
        "emptyTitle": "Personalizando tus encuentros",
        "emptySubtitle": "Completa el cuestionario para ver encuentros recomendados para ti.",
        "startOnboarding": "Personalizar"
      }
    },
    "card": {
      "nextSession": "próxima sesión: {weekday} {time}"
    }
  },
  "trail": {
    "title": "Camino",
    "subtitle": "Tu viaje personal de recuperación",
    "step": "Paso",
    "progress": "Progreso",
    "complete": "Completar",
    "completed": "Completado",
    "description": "Descripción",
    "progressLabel": "Completado",
    "locked": "Bloqueado",
    "lockedMessage": "Completa el paso anterior para desbloquear",
    "lockButtonText": "Continuar",
    "reset": "Reiniciar Camino",
    "resetConfirm": "¿Estás seguro de que deseas reiniciar tu camino?",
    "resetTitle": "¿Reiniciar Camino?",
    "resetMessage": "¿Estás seguro de que deseas reiniciar tu camino?\n\nTodo tu progreso se perderá y volverás al primer paso. Esta acción no se puede deshacer.",
    "resetButton": "Sí, reiniciar",
    "resetting": "Reiniciando...",
    "cancelButton": "Cancelar",
    "intro": "Introducción",
    "introTitle": "El Camino",
    "introSubtitle": "Entiende cómo funciona",
    "introModalTitle": "Cómo Funciona el Camino",
    "introModalMessage": "El Camino es una ruta estructurada basada en el programa de recuperación.\n\nCompleta cada paso en orden para desbloquear el siguiente. Cada paso contiene contenido importante para tu viaje de recuperación.\n\nLee cuidadosamente y reflexiona sobre cada etapa antes de avanzar.",
    "introButton": "Entendido",
    "lockedModalTitle": "Paso Bloqueado",
    "lockedModalMessage": "Este paso aún está bloqueado. Completa los pasos anteriores para desbloquear este contenido.",
    "lockedButton": "Entendido",
    "index": "Índice",
    "actions": {
      "exit": "Salir",
      "completeReading": "Completar lectura",
      "scrollToEnd": "Desplázate hasta el final",
      "listen": "Escuchar",
      "listening": "Escuchando"
    },
    "csat": {
      "title": "¿Qué te pareció el contenido?"
    },
    "hints": {
      "readToComplete": "Lee hasta el final para completar este paso"
    },
    "accessibility": {
      "pausePlayer": "Pausar y abrir reproductor",
      "listenStep": "Escuchar paso",
      "audioPlusGated": "Audio exclusivo Padrinho Plus — toca para saber más"
    },
    "congratulations": {
      "message": "¡Felicitaciones! Completaste el",
      "completedStepMessage": "¡Felicitaciones! Completaste el paso {stepTitle} del camino {trailName}"
    },
    "home": {
      "continueLearning": "Continúa tus caminos",
      "suggestedTrails": "Caminos para ti",
      "newTrails": "Novedades",
      "tabs": {
        "mine": "Iniciadas",
        "forYou": "Para ti",
        "explore": "Explorar"
      },
      "steps": "etapas",
      "favorite": "Guardar",
      "favorited": "Guardado",
      "noMine": "Aún no has iniciado ningún camino",
      "noMineSubtitle": "Explora nuestros caminos y comienza tu viaje",
      "noForYou": "No hay caminos sugeridos en este momento",
      "otherTrails": "Otros caminos",
      "started": "En progreso",
      "iniciadas": {
        "emptyTitle": "Aprende sobre la recuperación, inicia un camino",
        "emptyButton": "Explorar caminos"
      }
    },
    "category": {
      "trails": "Caminos",
      "empty": "No hay caminos en esta categoría",
      "emptySubtitle": "Se agregarán nuevos caminos pronto"
    },
    "start": {
      "title": "Iniciar camino",
      "steps": "lecciones",
      "button": "Iniciar camino",
      "plusButton": "Hazte Plus para acceder"
    },
    "audio": {
      "stepLabel": "{number}º Paso"
    }
  },
  "communityProfile": {
    "memberSince": "Miembro desde {date}",
    "follow": "Seguir",
    "following": "Siguiendo",
    "message": "Mensaje",
    "posts": "Publicaciones",
    "now": "Ahora",
    "minutesAgo": "{count}min",
    "hoursAgo": "{count}h",
    "yesterday": "Ayer",
    "daysAgo": "{count}d",
    "editProfile": "Editar perfil",
    "loading": "Cargando...",
    "noPostsYet": "Este usuario aún no ha publicado nada.",
    "noPostsYetSelf": "Aún no has hecho ninguna publicación.",
    "anonymous": "Anónimo",
    "statsFollowing": "Siguiendo",
    "statsFriends": "Amigos",
    "statsPosts": "Posts",
    "options": "Opciones",
    "editPost": "Editar publicación",
    "deletePost": "Eliminar publicación",
    "postRemovedSuccess": "Publicación eliminada con éxito",
    "postRemoveError": "Error al eliminar publicación",
    "recentlyParticipated": "Participó recientemente",
    "liveNow": "En vivo ahora",
    "live": "En vivo",
    "todayAt": "Hoy a las "
  },
  "communityChat": {
    "online": "En línea",
    "offline": "Desconectado",
    "placeholder": "Escribe un mensaje...",
    "send": "Enviar"
  },
  "settings": {
    "title": "Configuración",
    "profile": "Perfil",
    "language": "Idioma",
    "notifications": "Notificaciones",
    "privacy": "Privacidad",
    "about": "Acerca de",
    "logout": "Cerrar Sesión",
    "account": "Cuenta"
  },
  "notifications": {
    "title": "Notificaciones",
    "settings": "Configuración de notificaciones",
    "adminOnly": "Esta área solo está disponible para administradores.",
    "groups": {
      "today": "Hoy",
      "yesterday": "Ayer",
      "thisWeek": "Esta semana",
      "older": "Más antiguo"
    },
    "empty": {
      "title": "Aún no has recibido notificaciones"
    },
    "meetingReminder": {
      "withCategory": "Tu reunión de {category} de {meetingName} empieza en 15 minutos"
    },
    "pushNotifications": "Notificaciones push",
    "pushDescription": "Recibe recordatorios y mensajes importantes de tu camino de recuperación.",
    "whatYouWillReceive": "Lo que vas a recibir",
    "receiveList": "Recordatorios de reuniones, mensajes de tu padrino, hitos de sobriedad y novedades de la comunidad.",
    "privacyTitle": "Privacidad",
    "privacyNote": "Tus notificaciones son personales y seguras. Puedes desactivarlas en cualquier momento en la configuración del dispositivo.",
    "statusAllowed": "Permitido",
    "statusDenied": "Denegado",
    "statusSubscribed": "Suscrito",
    "statusNotSubscribed": "No suscrito",
    "enabledSuccess": "¡Notificaciones activadas con éxito!",
    "permissionDenied": "Permiso de notificación denegado. Puedes activarlo en la configuración del dispositivo.",
    "disabled": "Notificaciones desactivadas",
    "disabledAlertMessage": "Ya no recibirás notificaciones push. Puedes reactivarlas cuando quieras.",
    "understood": "Entendido",
    "errorLoading": "No se pudieron cargar las configuraciones de notificación. Inténtalo de nuevo.",
    "serviceUnavailable": "El servicio de notificaciones no está disponible en este momento. Inténtalo más tarde.",
    "unsupportedEnvironment": "Las notificaciones no son compatibles con este entorno.",
    "initializationFailed": "Error al inicializar las notificaciones. Inténtalo de nuevo.",
    "webUnsupported": "Las notificaciones no son compatibles con la versión web.",
    "expoGoUnsupported": "Las notificaciones no funcionan en Expo Go. Usa una compilación de desarrollo.",
    "oneSignalNotConfigured": "El servicio de notificaciones no está configurado.",
    "expoGoWarningTitle": "Expo Go detectado",
    "expoGoWarningMessage": "Las notificaciones push no están disponibles en Expo Go. Usa una compilación de desarrollo o producción para probarlas.",
    "webWarningTitle": "Versión web",
    "webWarningMessage": "Las notificaciones push no son compatibles con la versión web de la aplicación.",
    "oneSignalWarningTitle": "Notificaciones no configuradas",
    "oneSignalWarningMessage": "El servicio de notificaciones aún no se ha configurado en este entorno."
  },
  "account": {
    "changeEmail": {
      "title": "Cambiar correo",
      "subtitle": "Ingresa la nueva dirección de correo para tu cuenta.",
      "subtitleStep1": "Por tu seguridad, primero confirma tu contraseña actual.",
      "currentEmail": "Correo actual:",
      "newEmail": "Nuevo correo",
      "currentPassword": "Contraseña actual",
      "passwordPlaceholder": "Ingresa tu contraseña actual",
      "emailPlaceholder": "Ingresa tu nuevo correo",
      "button": "Cambiar correo",
      "backToProfile": "Volver al perfil",
      "errorPassword": "Contraseña incorrecta",
      "errorTooManyAttempts": "Demasiados intentos de inicio de sesión. Espera unos minutos e intenta de nuevo.",
      "errorEmailInUse": "Este correo ya está siendo usado por otra cuenta",
      "errorRateLimit": "Demasiados intentos de cambio de correo. Espera unos minutos antes de intentar de nuevo.",
      "errorGeneric": "Error al cambiar correo",
      "errorUserInfo": "Error al obtener información del usuario",
      "successTitle": "Correo cambiado",
      "successMessage": "¡Tu correo ha sido cambiado con éxito!",
      "confirmationTitle": "Verificación enviada",
      "confirmationMessage": "Enviamos un correo de confirmación a:",
      "confirmationInstructions": "Haz clic en el enlace del correo para confirmar el cambio. Es posible que necesites revisar tu carpeta de spam."
    },
    "changePassword": {
      "title": "Cambiar contraseña",
      "subtitle": "Elige una nueva contraseña fuerte para proteger tu cuenta.",
      "currentPassword": "Contraseña actual",
      "newPassword": "Nueva contraseña",
      "confirmPassword": "Confirmar nueva contraseña",
      "passwordPlaceholder": "Ingresa tu contraseña actual",
      "newPasswordPlaceholder": "Ingresa tu nueva contraseña",
      "confirmPasswordPlaceholder": "Confirma tu nueva contraseña",
      "requirements": "Tu contraseña debe tener:",
      "requirement1": "Mínimo 8 caracteres",
      "requirement2": "Una letra mayúscula",
      "requirement3": "Una letra minúscula",
      "requirement4": "Un número",
      "button": "Cambiar contraseña",
      "buttonLoading": "Cambiando...",
      "errorUserInfo": "Error al obtener información del usuario",
      "errorWrongPassword": "Contraseña actual incorrecta",
      "errorPasswordMismatch": "Las contraseñas no coinciden",
      "errorPasswordRequirements": "La nueva contraseña no cumple con los requisitos",
      "errorSamePassword": "La nueva contraseña debe ser diferente de la actual",
      "successTitle": "Contraseña cambiada",
      "successMessage": "¡Tu contraseña ha sido cambiada con éxito!"
    },
    "changePhone": {
      "title": "Cambiar teléfono",
      "titleSet": "Configurar teléfono",
      "subtitle": "Para tu seguridad, primero confirma tu contraseña actual.",
      "subtitleNew": "Ingresa el nuevo número de teléfono que deseas usar.",
      "subtitleFirst": "Ingresa tu número de teléfono para recibir notificaciones importantes.",
      "currentPhone": "Teléfono actual:",
      "label": "Número de teléfono",
      "labelNew": "Nuevo número",
      "phoneNumber": "Número de teléfono",
      "newPhoneNumber": "Nuevo número",
      "currentPassword": "Contraseña actual",
      "passwordPlaceholder": "Ingresa tu contraseña actual",
      "phonePlaceholder": "(11) 99999-9999",
      "phoneHint": "Ingresa solo números, formatearemos automáticamente",
      "button": "Cambiar teléfono",
      "buttonSet": "Configurar teléfono",
      "buttonLoading": "Guardando...",
      "buttonContinue": "Continuar",
      "verifying": "Verificando...",
      "errorPassword": "Contraseña incorrecta",
      "errorPasswordRequired": "Ingresa tu contraseña actual",
      "errorInvalidPhone": "Por favor ingresa un número válido",
      "errorSamePhone": "El nuevo número debe ser diferente del actual",
      "errorGeneric": "Error al cambiar teléfono",
      "successTitle": "Teléfono cambiado",
      "successMessage": "¡Tu número de teléfono ha sido cambiado con éxito!"
    },
    "changeName": {
      "title": "Cambiar apodo",
      "subtitle": "Cambia tu apodo para personalizar tu experiencia.",
      "label": "Nuevo apodo",
      "placeholder": "Ingresa tu nuevo apodo",
      "button": "Cambiar apodo",
      "buttonLoading": "Guardando...",
      "errorRequired": "Por favor ingresa un apodo",
      "errorUserNotFound": "Usuario no encontrado",
      "errorGeneric": "No se pudo actualizar el apodo. Intenta de nuevo.",
      "successMessage": "¡Apodo actualizado con éxito!"
    },
    "changeUsername": {
      "title": "Nombre de usuario",
      "subtitle": "Elige un nombre de usuario único para que otros puedan mencionarte en la comunidad.",
      "currentLabel": "Tu nombre de usuario actual",
      "label": "Nombre de usuario",
      "placeholder": "ej: juan.perez",
      "hint": "Letras, números, puntos y guiones bajos. Mín. 3, máx. 30 caracteres.",
      "checking": "Verificando...",
      "available": "Disponible",
      "unavailable": "Ya está en uso",
      "button": "Guardar nombre de usuario",
      "buttonLoading": "Guardando...",
      "errorRequired": "Por favor elige un nombre de usuario",
      "errorUserNotFound": "Usuario no encontrado",
      "errorGeneric": "No se pudo actualizar el nombre de usuario. Intenta de nuevo.",
      "successMessage": "¡Nombre de usuario actualizado con éxito!"
    },
    "deleteAccount": {
      "title": "Eliminar cuenta",
      "question": "¿Estás seguro de que deseas eliminar tu cuenta?",
      "warningTitle": "Al eliminar tu cuenta, perderás:",
      "warningItem1": "Todos tus datos de sobriedad y progreso",
      "warningItem2": "Historial de notas y reflexiones",
      "warningItem3": "Acceso a reuniones en línea y comunidad",
      "warningItem4": "Configuraciones personalizadas de la aplicación",
      "warningItem5": "Acceso a Bill (asistente virtual)",
      "warningFooter": "Esta acción no se puede deshacer. Tu cuenta y todos los datos serán eliminados permanentemente de inmediato.",
      "alternativeTitle": "¿Necesitas un descanso?",
      "alternativeText": "Si estás pasando por dificultades, considera hablar con nuestro equipo de apoyo antes de eliminar tu cuenta. Estamos aquí para ayudar.",
      "cancelButton": "Cancelar",
      "deleteButton": "Eliminar cuenta",
      "deleteButtonLoading": "Procesando...",
      "confirmTitle": "Confirmar eliminación",
      "confirmMessage": "¿Estás seguro de que deseas eliminar tu cuenta? Todos tus datos serán eliminados inmediatamente y esta acción no se puede deshacer.",
      "confirmCancel": "Cancelar",
      "confirmDelete": "Eliminar inmediatamente",
      "errorUserNotFound": "Error: usuario no encontrado",
      "errorSessionNotFound": "Error: sesión no encontrada",
      "errorGeneric": "Error al eliminar cuenta",
      "successMessage": "Cuenta eliminada con éxito"
    },
    "subscription": {
      "title": "Mi Plan",
      "pageTitle": "Mi plan",
      "basePlan": "Base",
      "activeBadge": "Activo",
      "since": "desde",
      "planDescriptionPlus": "Acceso completo a las funciones premium de la aplicación y soporte prioritario.",
      "planDescriptionBase": "Acceso gratuito a las funciones de la aplicación y su comunidad.",
      "upgradeTitle": "Padrinho Plus",
      "upgradeSubtitle": "Desde $4.99/mes",
      "providerText": "Ver toda la información y canales de contacto de tu proveedor",
      "features": {
        "bill": {
          "title": "Bill, tu padrino digital",
          "description": "Conversaciones inteligentes 24/7 para apoyo y orientación (30 mensajes mensuales)"
        },
        "billPlus": {
          "title": "Bill Plus",
          "description": "Tu padrino digital ilimitado, conectado a tu diario, reloj de sobriedad y check-ins de reuniones para apoyarte mejor en tu camino"
        },
        "meetings": {
          "title": "Reuniones en línea",
          "description": "Reuniones en línea con múltiples comunidades anónimas"
        },
        "exclusiveMeetings": {
          "title": "Encuentros exclusivos",
          "description": "Encuentros en vivo exclusivos para suscriptores Plus"
        },
        "exclusiveTrails": {
          "title": "Caminos exclusivos",
          "description": "Caminos de recuperación exclusivos para suscriptores Plus"
        },
        "diary": {
          "title": "Diario y Check-ins",
          "description": "Registra pensamientos, sentimientos y participación en reuniones en línea"
        },
        "clock": {
          "title": "Reloj de sobriedad",
          "description": "Marca tu progreso en el tiempo y celebra cada logro"
        },
        "progress": {
          "title": "Progreso en tiempo real",
          "description": "Sigue tu progreso día a día"
        },
        "clinicConnection": {
          "title": "Conexión con clínicas",
          "description": "Comunicación directa con tu clínica proveedora"
        },
        "scheduling": {
          "title": "Agendamiento & Profesionales",
          "description": "Agendamiento con profesionales para apoyo en tu camino"
        }
      },
      "securityText": "Todos tus datos están protegidos y son confidenciales",
      "termsLink": "Términos de Uso (EULA)",
      "upgrade": "Actualizar a Plus",
      "successUpgrade": "¡Éxito!",
      "successUpgradeMessage": "¡Bienvenido a Padrinho Plus!",
      "error": "Error",
      "errorMessage": "No se pudo abrir la pantalla de suscripción.",
      "manageSubscription": "Gestionar suscripción",
      "mySubscription": "Mi suscripción",
      "errorTermsOfUse": "No se pudo abrir los Términos de Uso."
    },
    "provider": {
      "title": "Proveedor",
      "phone": "Teléfono",
      "whatsapp": "WhatsApp",
      "email": "Correo",
      "website": "Sitio web",
      "websiteTitle": "Sitio web de la Clínica",
      "instagram": "Instagram",
      "schedule": "Horario",
      "loading": "Cargando...",
      "noData": "No hay información del proveedor disponible",
      "attendance": "Atención",
      "contactChannels": "Canales de contacto",
      "address": "Dirección",
      "providerNotFound": "Proveedor no encontrado"
    },
    "interests": {
      "title": "Mis intereses",
      "pageTitle": "Elige los temas que más te interesan",
      "subtitle": "Elige al menos 3 temas de interés",
      "button": "Actualizar mis intereses",
      "buttonLoading": "Guardando...",
      "errorMinimum": "Por favor, elige al menos 3 temas de interés.",
      "errorUserNotFound": "Error: usuario no encontrado",
      "errorGeneric": "Error al actualizar intereses. Inténtalo de nuevo.",
      "successMessage": "¡Intereses actualizados con éxito!"
    },
    "languageSettings": {
      "title": "Idioma",
      "button": "Elegir"
    }
  },
  "profile": {
    "title": "Perfil",
    "greeting": {
      "hello": "Hola, ",
      "wave": " 👋"
    },
    "sections": {
      "yourInfo": "Tu información",
      "subscription": "Suscripción",
      "security": "Seguridad",
      "app": "Aplicación",
      "padrinho": "Padrinho"
    },
    "fields": {
      "nickname": "Apodo",
      "username": "Nombre de usuario",
      "email": "Correo electrónico",
      "phone": "Teléfono",
      "notInformed": "No informado",
      "myPlan": "Mi plan",
      "basePlan": "Base",
      "provider": "Proveedor",
      "changePassword": "Cambiar contraseña",
      "myInterests": "Mis intereses",
      "myInterestsSubtitle": "Configura lo que ves en la aplicación",
      "language": "Idioma",
      "widget": "Widget",
      "widgetSubtitle": "Vista previa del widget de pantalla"
    },
    "languages": {
      "pt": "Português (Brasil)",
      "en": "English (United States)",
      "es": "Español (España)"
    },
    "upgrade": {
      "title": "Padrinho Plus",
      "subtitle": "Desde $4.99/mes"
    },
    "csat": {
      "title": "¿Cómo es tu experiencia en la app?",
      "subtitle": "Cuéntanos"
    },
    "logout": {
      "title": "Cerrar Sesión",
      "message": "¿Estás seguro de que deseas cerrar sesión de tu cuenta?",
      "cancel": "Cancelar",
      "confirm": "Cerrar Sesión"
    },
    "deleteAccount": {
      "label": "Eliminar mi cuenta"
    },
    "defaults": {
      "userName": "Usuario"
    },
    "share": {
      "inviteTitle": "Invitación a Padrinho",
      "shareError": "Error al compartir",
      "inviteMessage": "¡Hola! Descubrí una aplicación increíble que me está ayudando mucho en mi recuperación. Se llama Padrinho y tiene reuniones en línea, reloj de sobriedad y mucho más. Descárgala aquí: https://www.padrinho.app/downloads"
    },
    "cards": {
      "compass": {
        "tag": "Brújula",
        "title": "¡La información es el norte para tu recuperación!",
        "subtitle": "Accede al blog"
      },
      "community": {
        "tag": "Comunidad",
        "title": "Comparte tu historia y experiencia con otros miembros",
        "subtitle": "Únete a WhatsApp"
      },
      "podcast": {
        "tag": "En el Camino",
        "title": "Contenidos en audio para complementar tu programa",
        "subtitle": "Escucha en Spotify"
      },
      "invite": {
        "title": "Invita a alguien a Padrinho",
        "subtitle": "Comparte la invitación"
      }
    },
    "menu": {
      "title": "Menu",
      "hello": "Hola,",
      "moreContent": "Más contenidos",
      "diaryTitle": "Diario",
      "diarySubtitle": "Notas, sentimientos y mensajes"
    },
    "errors": {
      "loadProfile": "Error al cargar perfil",
      "retry": "Intentar de Nuevo",
      "backToLogin": "Volver al Inicio de Sesión",
      "userNotFound": "Usuario no encontrado",
      "userDataError": "No se pudo cargar los datos del usuario",
      "makeLogin": "Iniciar Sesión"
    },
    "toasts": {
      "phoneChangedSuccess": "¡Teléfono cambiado con éxito!",
      "authError": "Error de autenticación. Intenta de nuevo.",
      "noImageSelected": "Ninguna imagen seleccionada",
      "invalidFile": "Archivo inválido",
      "uploadingPhoto": "Subiendo foto...",
      "uploadFailed": "No se pudo subir la imagen",
      "photoUpdated": "¡Foto de perfil actualizada!",
      "permissionRequired": "Permiso necesario para acceder a la galería",
      "connectionError": "Error de conexión. Intenta de nuevo.",
      "permissionDenied": "Permiso denegado para acceder a galería",
      "photoUpdateError": "Error al cambiar foto de perfil",
      "unexpectedError": "Error inesperado. Intenta de nuevo.",
      "nameUpdateError": "Error al actualizar nombre",
      "nameSaved": "¡Nombre guardado con éxito!",
      "logoutError": "Error al cerrar sesión",
      "plusUpgradeSuccess": "¡Felicitaciones! ¡Ahora tienes acceso a Padrinho Plus!",
      "paywallError": "No se pudo abrir la pantalla de suscripción.",
      "subscriptionManagementError": "No se pudo abrir la gestión de suscripción."
    }
  },
  "common": {
    "save": "Guardar",
    "cancel": "Cancelar",
    "delete": "Eliminar",
    "edit": "Editar",
    "close": "Cerrar",
    "back": "Atrás",
    "next": "Siguiente",
    "loading": "Cargando...",
    "error": "Error",
    "success": "¡Éxito!",
    "confirm": "Confirmar",
    "yes": "Sí",
    "no": "No",
    "and": "y",
    "of": "de",
    "apply": "Aplicar",
    "clearFilters": "Limpiar filtros",
    "now": "Ahora",
    "today": "Hoy",
    "tomorrow": "Mañana",
    "yesterday": "Ayer",
    "months": {
      "january": "enero",
      "february": "febrero",
      "march": "marzo",
      "april": "abril",
      "may": "mayo",
      "june": "junio",
      "july": "julio",
      "august": "agosto",
      "september": "septiembre",
      "october": "octubre",
      "november": "noviembre",
      "december": "diciembre"
    },
    "weekdays": {
      "short": {
        "sunday": "Dom",
        "monday": "Lun",
        "tuesday": "Mar",
        "wednesday": "Mié",
        "thursday": "Jue",
        "friday": "Vie",
        "saturday": "Sáb"
      },
      "long": {
        "sunday": "Domingo",
        "monday": "Lunes",
        "tuesday": "Martes",
        "wednesday": "Miércoles",
        "thursday": "Jueves",
        "friday": "Viernes",
        "saturday": "Sábado"
      }
    },
    "periods": {
      "morning": "Mañana",
      "afternoon": "Tarde",
      "evening": "Noche"
    },
    "categories": {
      "supportGroup": "Grupo de Apoyo",
      "workshop": "Taller",
      "meditation": "Meditación",
      "therapy": "Terapia",
      "sharing": "Compartir",
      "reuniaoNovos": "Reunión para Recién Llegados",
      "reuniaoPartilhas": "Reunión de Compartir",
      "reuniaoTematica": "Reunión Temática",
      "reuniaoEstudoLiteratura": "Estudio de Literatura",
      "reuniaoAteusAgnosticos": "Ateos y Agnósticos",
      "reuniaoLgbtqiapn": "LGBTQIAPN+",
      "reuniaoCodependentes": "Codependientes",
      "reuniaoPassos": "Reunión de Pasos",
      "reuniaoTradicoes": "Reunión de Tradiciones"
    },
    "alert": {
      "errorTitle": "Error",
      "successTitle": "¡Éxito!",
      "infoTitle": "Información"
    }
  },
  "calendar": {
    "title": "Diario de sentimientos",
    "congratsGreeting": "¡Felicidades!",
    "congratsMiddle": " Registraste ",
    "congratsCountUnit": "sentimientos",
    "congratsEnd": " en los últimos 7 días"
  },
  "filters": {
    "author": {
      "you": "Tú",
      "bill": "Bill"
    },
    "period": {
      "last7days": "Últimos 7 días",
      "last15days": "Últimos 15 días",
      "last30days": "Últimos 30 días"
    },
    "time": "Horario",
    "dayOfWeek": "Día de la semana"
  },
  "group": {
    "title": "Grupo",
    "filters": {
      "time": "Horario",
      "dayOfWeek": "Día de la semana",
      "category": "Categoría"
    },
    "errors": {
      "notFound": "Grupo no encontrado",
      "noMeetings": "No se encontraron encuentros"
    },
    "liveNow": "En vivo ahora",
    "todayAt": "Hoy a las"
  },
  "meeting": {
    "liveNow": "En vivo ahora",
    "startsInMinutes": "Comienza en {minutes} {unit}",
    "startsInHours": "Comienza en {hours} {unit}",
    "startsInHoursMinutes": "Comienza en {hours}h{minutes}",
    "endedMinutesAgo": "Terminó hace {minutes} {unit}",
    "endedHoursAgo": "Terminó hace {hours}h{minutes}",
    "timeError": "Error al calcular el horario",
    "timeNotSpecified": "Horario no especificado",
    "notSpecified": "No especificado",
    "everyDay": "Todos los días",
    "mondayToFriday": "Lunes a viernes",
    "weekends": "Fines de semana",
    "everyDayName": "Todos los {day}",
    "and": "y",
    "andOthers": "y otros",
    "minute": "minuto",
    "minutes": "minutos",
    "hour": "hora",
    "hours": "horas",
    "errors": {
      "loadFailed": "No se pudo cargar la información de la reunión",
      "loginRequired": "Debes iniciar sesión para unirte a la reunión",
      "linkUnavailable": "Enlace de reunión no disponible"
    }
  },
  "email": {
    "errors": {
      "notFound": "Correo electrónico no encontrado",
      "resendFailed": "Error al reenviar el enlace. Inténtalo de nuevo.",
      "unexpectedError": "Error inesperado. Inténtalo de nuevo."
    },
    "success": {
      "resent": "¡Enlace reenviado con éxito!"
    }
  },
  "community": {
    "header": {
      "title": "Comunidad"
    },
    "tabs": {
      "forYou": "Para ti",
      "following": "Siguiendo"
    },
    "author": {
      "anonymous": "Anónimo",
      "default": "Usuario"
    },
    "emptyState": {
      "title": "¡Tus huellas quedan marcadas aquí en la comunidad!",
      "subtitle": "Deja tu mensaje para los miembros que aún están llegando"
    },
    "actions": {
      "options": "Opciones",
      "editPost": "Editar publicación",
      "deletePost": "Eliminar publicación"
    },
    "toast": {
      "postRemoved": "Publicación eliminada con éxito",
      "postRemoveError": "Error al eliminar publicación",
      "postUpdated": "Publicación actualizada con éxito",
      "postUpdateError": "Error al actualizar publicación"
    },
    "timestamp": {
      "now": "Ahora",
      "yesterday": "Ayer"
    },
    "newPost": {
      "titleComment": "Nuevo Comentario",
      "titlePost": "Nuevo Testimonio",
      "editTitle": "Editar publicación",
      "publish": "Publicar",
      "save": "Guardar",
      "cancel": "Cancelar",
      "addTopic": "Agregar tema",
      "topicsCount": "{count} temas",
      "placeholder": "¿Qué tienes en mente ahora?",
      "defaultUser": "Usuario"
    },
    "post": {
      "headerTitle": "Comunidad",
      "firstToEncourage": "¡Sé el primero en animar!",
      "commentPlaceholder": "Escribe un aliento...",
      "options": "Opciones",
      "editPost": "Editar publicación",
      "deletePost": "Eliminar publicación",
      "postRemoved": "Publicación eliminada con éxito",
      "postRemoveError": "Error al eliminar publicación",
      "anonymous": "Anónimo",
      "defaultAuthor": "Usuario",
      "timestampNow": "Ahora"
    },
    "publishing": {
      "publishing": "Publicando...",
      "error": "No se pudo publicar",
      "success": "¡Publicado con éxito!"
    },
    "topics": {
      "title": "Temas",
      "save": "Guardar",
      "searchPlaceholder": "Buscar tema…",
      "notFound": "No se encontraron temas",
      "labels": {
        "Abstinência": "Abstinencia",
        "Adultos 60+": "Adultos 60+",
        "Álcool": "Alcohol",
        "Ansiedade": "Ansiedad",
        "Apadrinhamento": "Apadrinamiento",
        "Autocompaixão": "Autocompasión",
        "Autoconhecimento": "Autoconocimiento",
        "Autocontrole": "Autocontrol",
        "Bariátrica": "Bariátrica",
        "Burnout": "Burnout",
        "Comunicação": "Comunicación",
        "Compras Compulsivas": "Compras Compulsivas",
        "Dependência Digital": "Adicción Digital",
        "Depressão": "Depresión",
        "Drogas / Psicoativos": "Drogas / Psicoactivos",
        "Emoções": "Emociones",
        "Estresse": "Estrés",
        "Família": "Familia",
        "Feminilidade": "Feminidad",
        "Gatilhos": "Desencadenantes",
        "Internação": "Internación",
        "Jogos": "Juegos de Azar",
        "Juventude": "Juventud",
        "LGBT+": "LGBT+",
        "Limites": "Límites",
        "Lucidez": "Lucidez",
        "Masculinidade": "Masculinidad",
        "Maternidade": "Maternidad",
        "Neurodivergência": "Neurodivergencia",
        "Novos na Recuperação": "Nuevos en Recuperación",
        "Outras Dependências": "Otras Adicciones",
        "Paternidade": "Paternidad",
        "Pornografia": "Pornografía",
        "Prevenção de Recaída": "Prevención de Recaída",
        "Psiquiatria & Medicação": "Psiquiatría & Medicación",
        "Raiva": "Ira",
        "Recomeços": "Nuevos Comienzos",
        "Rede de Apoio": "Red de Apoyo",
        "Redes Sociais": "Redes Sociales",
        "Relacionamentos": "Relaciones",
        "Ressaca": "Resaca",
        "Rotina de Sobriedade": "Rutina de Sobriedad",
        "Sexo": "Sexo",
        "Sobriedade Longa": "Sobriedad Prolongada",
        "Solidão": "Soledad",
        "Terapia": "Terapia",
        "Transtornos Alimentares": "Trastornos Alimentarios",
        "Tratamento": "Tratamiento",
        "Vergonha & Culpa": "Vergüenza & Culpa",
        "Vida Sexual Saudável": "Vida Sexual Saludable"
      }
    }
  },
  "padrinho": {
    "website": "Sitio web",
    "privacy": "Políticas de uso y privacidad",
    "help": "Ayuda"
  },
  "csat": {
    "pageTitle": "Evaluación",
    "title": "Evalúa tu experiencia en la app Padrinho",
    "starsInstruction": "Elige de 1 a 5 estrellas para calificar",
    "topicsTitles": {
      "negative": "¿Qué está mal?",
      "neutral": "¿Qué puede mejorar?",
      "positive": "¿Qué te gustó?"
    },
    "topics": {
      "negative": {
        "crashes": "Bloqueos",
        "slowPerformance": "Lentitud",
        "confusingNavigation": "Navegación confusa",
        "billResponses": "Respuestas de Bill",
        "notifications": "Notificaciones",
        "design": "Diseño",
        "meetings": "Encuentros",
        "trail": "Camino de los 12 pasos",
        "diary": "Diario emocional"
      },
      "neutral": {
        "navigation": "Navegación",
        "billQuality": "Calidad de Bill",
        "design": "Diseño",
        "performance": "Rendimiento",
        "notifications": "Notificaciones",
        "meetings": "Encuentros",
        "trail": "Camino de los 12 pasos",
        "diary": "Diario emocional",
        "community": "Comunidad"
      },
      "positive": {
        "easeOfUse": "Fácil de usar",
        "billHelp": "Ayuda de Bill",
        "design": "Diseño bonito",
        "meetings": "Encuentros",
        "trail": "Camino de los 12 pasos",
        "diary": "Diario emocional",
        "sobrietyClock": "Reloj de sobriedad",
        "community": "Comunidad",
        "notifications": "Notificaciones"
      },
      "other": "Otro"
    },
    "commentTitle": "Deja tu comentario",
    "commentPlaceholder": "Cuéntanos más sobre tu experiencia...",
    "submit": "Enviar evaluación",
    "submitting": "Enviando...",
    "alerts": {
      "selectRating": "Por favor, selecciona una calificación",
      "error": "Error al enviar la evaluación. Inténtalo de nuevo."
    },
    "success": {
      "title": "¡Gracias por tu feedback!",
      "subtitle": "Tu evaluación ha sido enviada con éxito. Es muy importante para que sigamos mejorando la app.",
      "button": "Volver"
    },
    "callTitle": "Califica tu experiencia en el encuentro",
    "callTopics": {
      "negative": {
        "audioQuality": "Calidad del audio",
        "videoQuality": "Calidad del video",
        "connectionDrops": "Caídas de conexión",
        "sponsorPreparedness": "Preparación del padrino",
        "scheduling": "Horario"
      },
      "neutral": {
        "audioQuality": "Calidad del audio",
        "videoQuality": "Calidad del video",
        "sponsorPreparedness": "Preparación del padrino",
        "callDuration": "Duración de la llamada",
        "scheduling": "Horario"
      },
      "positive": {
        "clearAudio": "Audio claro",
        "clearVideo": "Video nítido",
        "sponsorHelp": "Ayuda del padrino",
        "easyToConnect": "Fácil de conectar",
        "callDuration": "Duración de la llamada"
      }
    },
    "trailTitle": "¿Qué te pareció el contenido?",
    "trailTopics": {
      "negative": {
        "contentDifficult": "Difícil de entender",
        "contentNotRelevant": "Poco relevante para mí",
        "contentTooShort": "Demasiado corto",
        "contentTooLong": "Demasiado largo",
        "contentFewExamples": "Faltan ejemplos prácticos",
        "audioQuality": "Calidad del audio"
      },
      "neutral": {
        "contentDepth": "Profundidad del contenido",
        "contentPace": "Ritmo de lectura",
        "contentExamples": "Ejemplos prácticos",
        "contentLanguage": "Lenguaje usado",
        "audioExperience": "Experiencia con el audio"
      },
      "positive": {
        "contentClarity": "Contenido claro",
        "contentHelpful": "Me ayudó en la recuperación",
        "contentRelevant": "Contenido relevante",
        "contentExamples": "Buenos ejemplos prácticos",
        "audioQuality": "Buen audio"
      }
    }
  },
  "postCallCsat": {
    "sessionEnded": "Sesión finalizada",
    "headline": "Cuéntanos cómo fue tu experiencia",
    "rate": "Calificar mi experiencia",
    "skip": "Dejar para después"
  },
  "appointments": {
    "title": "Citas",
    "upcoming": "Próximas sesiones",
    "history": "Sesiones anteriores",
    "discoveryTitle": "Encuentra los profesionales adecuados para apoyarte en tu camino",
    "discoveryChips": "Abstinencia,Masculinidad,Dinero,Internación,Experiencia",
    "findProfessionals": "Encontrar profesionales",
    "discoveryError": "No pudimos cargar los profesionales ahora.",
    "noPastInline": "No tienes citas anteriores",
    "newAppointment": "Nueva cita",
    "contextTitle": "Opciones",
    "reschedule": "Reprogramar",
    "cancel": "Cancelar",
    "cancelAppointment": "Cancelar cita",
    "cancelTitle": "Cancelar cita",
    "cancelMessage": "¿Estás seguro de cancelar esta cita?",
    "cancelSuccess": "Cita cancelada con éxito",
    "cancelError": "Error al cancelar cita",
    "changeWindowDisclaimer": "Solo puedes cancelar o reprogramar hasta 24 horas antes de la sesión. Después de ese plazo, ya no es posible cancelar ni reprogramar.",
    "changeWindowClosed": "No puedes cancelar ni reprogramar dentro de las 24 horas previas a la sesión.",
    "loadError": "Error al cargar las citas",
    "pendingPayment": "Pago pendiente",
    "completePayment": "Completar pago"
  },
  "sponsors": {
    "details": {
      "crp": "CRP",
      "session": "Sesión",
      "price": "Valor por sesión",
      "durationMinutes": "{minutes} minutos",
      "sessionDuration": "Sesión de {minutes} minutos"
    },
    "scheduleSession": "Agendar sesión",
    "profile": {
      "findSponsorTitle": "Encuentra un profesional",
      "findSponsorSubtitle": "Agenda una cita",
      "scheduledTitle": "Citas",
      "role": "Mi Padrino",
      "scheduledFor": "Agendado para",
      "at": "a las",
      "scheduledDate": "Agendado para {{date}} a las {{time}}",
      "whatsappButton": "Enviar mensaje",
      "saveToCalendar": "Guardar en agenda",
      "joinRoom": "Entrar a la sesión",
      "joinRoomLoading": "Abriendo sesión…",
      "joinRoomTooEarly": "Disponible 30 min antes",
      "joinRoomError": "No pudimos abrir la sesión. Inténtalo de nuevo en unos segundos.",
      "menuTitle": "Opciones",
      "cancelAppointment": "Cancelar cita",
      "cancelTitle": "Cancelar cita",
      "cancelMessage": "¿Estás seguro de cancelar esta cita?",
      "cancelSuccess": "Cita cancelada con éxito",
      "cancelError": "Error al cancelar cita",
      "rescheduleSession": "Reprogramar sesión",
      "rescheduleTitle": "Reprogramar sesión",
      "rescheduleSuccess": "¡Sesión reprogramada con éxito!",
      "rescheduleError": "Error al reprogramar la sesión",
      "reschedulePastError": "No puedes reprogramar una sesión que ya pasó",
      "rescheduleSlotTaken": "Este horario ya no está disponible",
      "changeWindowClosed": "No puedes reprogramar dentro de las 24 horas previas a la sesión."
    },
    "list": {
      "title": "Profesionales",
      "subtitle": "Aquí están algunas sugerencias de Padrinos y Madrinas para ti",
      "padrinho": "Padrino",
      "madrinha": "Madrina",
      "viewAgendaButton": "Agendar sesión",
      "loading": "Cargando sugerencias...",
      "error": "Error al cargar padrinos",
      "empty": "No hay padrinos disponibles en este momento"
    },
    "agenda": {
      "title": "Agenda",
      "sessionDuration": "Sesiones de 45 minutos",
      "schedules": "Agendas del",
      "to": "al",
      "dateRange": "Agendas del {{startDate}} al {{endDate}}",
      "selectTime": "{{date}} a las {{time}}",
      "confirmButton": "Confirmar horario",
      "loading": "Cargando agenda...",
      "error": "Error al cargar horarios",
      "noSlots": "No hay horarios disponibles",
      "rescheduleConfirmButton": "Confirmar reprogramación",
      "rescheduling": "Reprogramando..."
    },
    "phone": {
      "headerTitle": "Contacto",
      "title": "Confirma tu celular",
      "subtitle": "Este será el medio de comunicación del profesional contigo si es necesario.",
      "placeholder": "( __ ) _____ - ____",
      "confirmButton": "Confirmar y agendar",
      "confirming": "Confirmando...",
      "saveError": "No pudimos guardar tu celular. Inténtalo de nuevo."
    },
    "payment": {
      "headerTitle": "Pago",
      "title": "Finalizar pago",
      "scheduledFor": "Cita para el {date} a las {time}",
      "methodTitle": "Forma de pago",
      "interimNotice": "Todavía no se realizará ningún cobro en línea. En este paso, solo confirmas la cita.",
      "pix": "Pix",
      "card": "Tarjeta",
      "comingSoon": "Próximamente",
      "amountLabel": "Importe a pagar",
      "priceUnavailable": "No se pudo cargar el importe",
      "confirmButton": "Finalizar pago",
      "invalidContext": "No pudimos validar los datos de la cita. Vuelve y elige el horario nuevamente.",
      "phoneMissing": "Confirma tu celular nuevamente antes de agendar.",
      "checkoutError": "No pudimos completar el pago. Tu horario se liberará si no se confirma el pago.",
      "finalizationPending": "Tu pago todavía se está confirmando. Revisa tus citas nuevamente en unos instantes.",
      "refundStartedTitle": "No pudimos confirmar tu sesión",
      "refundStartedMessage": "El pago fue aprobado, pero no pudimos reservar el horario. El reembolso ya comenzó automáticamente y no necesitas hacer nada.",
      "refundCompletedTitle": "Pago reembolsado",
      "refundCompletedMessage": "El pago fue reembolsado. El tiempo para que aparezca depende de tu institución financiera."
    },
    "success": {
      "header": "Cita",
      "title": "Cita agendada con éxito",
      "subtitlePrefix": "Notificaremos a",
      "subtitleSuffix": "sobre tu cita",
      "button": "Ver mis citas",
      "buttonCsat": "Calificar experiencia",
      "rescheduleHeader": "Reprogramación",
      "rescheduleTitle": "Sesión reprogramada con éxito",
      "rescheduleSubtitlePrefix": "Notificaremos a",
      "rescheduleSubtitleSuffix": "sobre el nuevo horario",
      "rescheduleButton": "Ver mis citas"
    },
    "enableNotifications": {
      "header": "Notificaciones",
      "title": "¡Activa tus notificaciones!",
      "subtitle": "Así podemos avisarte sobre tu conversación con {{sponsorName}}",
      "settingsButton": "Ir a configuraciones",
      "skipButton": "¡Ahora no!"
    },
    "weekdays": {
      "monday": "Lunes",
      "tuesday": "Martes",
      "wednesday": "Miércoles",
      "thursday": "Jueves",
      "friday": "Viernes",
      "saturday": "Sábado",
      "sunday": "Domingo"
    },
    "errors": {
      "title": "Error",
      "notPlusUser": "Esta función es exclusiva para suscriptores de Padrinho Plus",
      "loadError": "Error al cargar información",
      "scheduleError": "Error al agendar cita",
      "slotTaken": "Este horario ya no está disponible",
      "invalidPhone": "Por favor ingresa un número de teléfono válido"
    }
  },
  "biometric": {
    "loginButton": "Entrar con Face ID",
    "loginButtonFingerprint": "Entrar con huella digital",
    "enableTitle": "Entrar más rápido",
    "enableDescription": "Usa tu biometría para entrar en Padrinho sin escribir tu contraseña.",
    "enableButton": "Activar biometría",
    "notNow": "Ahora no",
    "settingTitle": "Face ID",
    "settingTitleFingerprint": "Biometría",
    "settingSubtitle": "Entra sin escribir tu contraseña",
    "disableConfirmTitle": "¿Desactivar biometría?",
    "disableConfirmMessage": "Necesitarás escribir tu contraseña para entrar.",
    "disableConfirmYes": "Desactivar",
    "disableConfirmNo": "Cancelar",
    "authReason": "Confirma tu identidad para entrar en Padrinho",
    "unavailable": "No disponible en este dispositivo"
  },
  "consent": {
    "updateTitle": "Términos Actualizados",
    "updateMessage": "Nuestros Términos de Servicio y Política de Privacidad han sido actualizados. Por favor, revise y acepte para continuar usando la aplicación.",
    "viewTerms": "Leer Términos y Política de Privacidad",
    "acceptCheckbox": "He leído y acepto los Términos de Servicio y la Política de Privacidad actualizados",
    "acceptButton": "Aceptar y Continuar",
    "acceptingButton": "Registrando...",
    "errorTitle": "Error",
    "errorMessage": "No se pudo registrar su consentimiento. Por favor, inténtelo de nuevo."
  },
  "widget": {
    "preview": {
      "title": "Vista previa del Widget",
      "label": "Widget Mediano (349 × 164)",
      "labelSmall": "Widget Pequeño (164 × 164)"
    },
    "guide": {
      "title": "Widget en inicio",
      "subtitle": "Ve tu contador de sobriedad directamente en la pantalla de inicio.",
      "done": "Entendido",
      "ios": {
        "step1": "Mantén presionada un área vacía de tu pantalla de inicio",
        "step2": "Toca el botón \"+\" en la esquina superior",
        "step3": "Busca \"Padrinho\" en la barra de búsqueda",
        "step4": "Elige el tamaño del widget que prefieras",
        "step5": "Toca \"Agregar widget\" para confirmar"
      },
      "android": {
        "step1": "Mantén presionada un área vacía de tu pantalla de inicio",
        "step2": "Toca \"Widgets\" en el menú que aparece",
        "step3": "Busca \"Padrinho\" en la lista de widgets",
        "step4": "Mantén presionado el widget y arrástralo a la pantalla de inicio"
      }
    }
  },
  "usernamePrompt": {
    "title": "Tu @usuario ha sido creado",
    "description": "Otros miembros de la comunidad pueden mencionarte en publicaciones usando tu handle.",
    "gotIt": "Entendido",
    "customize": "Personalizar handle"
  },
  "missoes": {
    "tabLabel": "Misiones",
    "todayHeading": "Tus misiones de hoy",
    "todayDateLabel": "Hoy, {date}",
    "empty": "No hay misiones hoy. Vuelve mañana.",
    "goalCard": {
      "title": "Mi objetivo",
      "stagePill": "Etapa {stageNumber} · {stageName}",
      "askBill": "Pregunta a Bill",
      "sobrietyFooter": "Llevas {days} días sobrio",
      "setSobriety": "Definir tiempo de sobriedad"
    },
    "encontros": {
      "heading": "Encuentros",
      "weekIntro": "Tu presencia en los últimos 7 días",
      "encouragement": "¡Felicidades! Asististe a <b>{count} encuentros</b> en los últimos 7 días",
      "encouragementOne": "¡Felicidades! Asististe a <b>1 encuentro</b> en los últimos 7 días",
      "encouragementZero": "Aún no has participado en encuentros esta semana"
    },
    "weekdays": {
      "sun": "Dom",
      "mon": "Lun",
      "tue": "Mar",
      "wed": "Mié",
      "thu": "Jue",
      "fri": "Vie",
      "sat": "Sáb"
    },
    "missions": {
      "participar_encontro": {
        "label": "Asistir a un encuentro",
        "helper": "Confirma tu asistencia a una reunión"
      },
      "registrar_diario_sentimentos": {
        "label": "Registrar en el diario de emociones",
        "helper": "Anota una emoción del día"
      },
      "progredir_trilha": {
        "label": "Avanzar en una trilla",
        "helper": "Continúa donde lo dejaste"
      },
      "apoiar_membro_comunidade": {
        "label": "Apoyar a un miembro de la comunidad",
        "helper": "Reacciona o comenta en una publicación"
      },
      "publicar_comunidade": {
        "label": "Publicar en la comunidad",
        "helper": "Comparte algo con quienes te acompañan"
      },
      "doneA11y": "completada"
    },
    "history": {
      "heading": "Historial",
      "yesterdayDateLabel": "Ayer, {date}",
      "dateNamed": "{date}",
      "week": "Semana",
      "month": "1 Mes",
      "threeMonths": "3 Meses",
      "sixMonths": "6 Meses",
      "twelveMonths": "12 Meses",
      "view": "Ver",
      "close": "Cerrar",
      "completedSummary": "Completaste {done} de {total} misiones",
      "loading": "Cargando...",
      "loadFailed": "No se pudo cargar este día.",
      "relapseMessage": "Hubo un nuevo comienzo, ¡no te rindas!",
      "supports": {
        "one": {
          "bold": "1 persona",
          "suffix": " recibió tu apoyo"
        },
        "many": {
          "bold": "{count} personas",
          "suffix": " recibieron tu apoyo"
        }
      },
      "posts": {
        "many": "Compartiste {count} reflexiones con la comunidad",
        "anonymous": "Anónimo",
        "you": "Tú"
      },
      "timeAgo": {
        "minute": "hace {n} min",
        "hour": "hace {n} h",
        "day": "hace {n} d"
      }
    },
    "origin": {
      "youArrivedAt": "Llegaste a Padrinho"
    },
    "errors": {
      "loadFailed": "No pudimos cargar tus misiones en este momento.",
      "retry": "Intentar de nuevo"
    }
  },
  "stageTransition": {
    "eyebrow": "NUEVA ETAPA",
    "title": "Avanzaste a {stageName}",
    "body": "{stageDescription}",
    "transitionLabel": "{from} → {to}",
    "primaryCta": "Continuar mi camino",
    "secondaryCta": "Más tarde"
  },
  "currentStage": {
    "headerTitle": "Tu etapa",
    "eyebrow": "MI ETAPA ACTUAL",
    "stageLabel": "Etapa {n} de 5",
    "primaryCta": "Ok, entendido"
  },
  "changeGoal": {
    "headerTitle": "Objetivo",
    "bodyTitle": "Define bien tu principal objetivo dentro de la aplicación",
    "cta": "Definir mi objetivo"
  },
  "billAsk": {
    "goalQuestion": "¿Cómo puedo desarrollar mi objetivo de \"{goal}\"?",
    "stageQuestion": "¿Cómo puedo avanzar en mi etapa actual de recuperación?"
  },
  "recoveryStages": {
    "1": {
      "name": "Inicio",
      "description": "Estás en la fase inicial. Mantente cerca de apoyo intensivo, es esencial ahora.",
      "defaultGoal": "Cuidarme hoy, un momento a la vez."
    },
    "2": {
      "name": "Fundación",
      "description": "Estás dando los primeros pasos. La base aún es frágil; el compromiso diario hace toda la diferencia.",
      "defaultGoal": "Construir una rutina que sostenga mi sobriedad."
    },
    "3": {
      "name": "Desarrollo",
      "description": "Patrones saludables empiezan a formarse. Mantener la consistencia es el foco de esta fase.",
      "defaultGoal": "Profundizar lo que funciona y descubrir nuevas fortalezas."
    },
    "4": {
      "name": "Fortalecimiento",
      "description": "Progreso sólido y confianza creciente. Sigue reforzando los hábitos que has construido.",
      "defaultGoal": "Mantener lo que funciona y cuidar los vínculos importantes."
    },
    "5": {
      "name": "Mantenimiento",
      "description": "Tu recuperación está estable. Es hora de reconstruir las áreas de la vida afectadas por la dependencia.",
      "defaultGoal": "Sostener mi sobriedad y aportar a quienes están comenzando."
    }
  }
}
